import { Netmask } from 'netmask';
import type { Network } from '#dn-types/network.ts';
import { getCidrV4 } from '#util/networkCidrs.ts';

export function detectNetworkOverlap(networks: Network[], cidr: string) {
  try {
    const block = new Netmask(cidr);

    for (const network of networks) {
      const networkCidr = getCidrV4(network);
      if (!networkCidr) continue;

      const testBlock = new Netmask(networkCidr);

      if (block.contains(testBlock.first) || testBlock.contains(block.first)) {
        return true;
      }
    }
  } catch {
    // noop
  }

  return false;
}
